export default __webpack_public_path__ + "static/media/team6.31c0b610.JPG";